//ブラウザがIEか判定を行う
export const isBrowserIe = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  //IEの場合は, IE以外の場合はfalseを返却する。
  return userAgent.indexOf('msie') !== -1 || userAgent.indexOf('trident') !== -1;
};

// ブラウザがEdgeか判定を行う
export const isBrouserEdge = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return userAgent.indexOf('edge') !== -1;
};

// iOS版Safariか判定を行う
export const isBrowserIOSSafari = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return (userAgent.indexOf('iphone') !== -1 || userAgent.indexOf('ipod') !== -1) && userAgent.indexOf('safari') !== -1;
};

// ipad版Safariか判定を行う
export const isBrowserIpadSafari = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return (
    (userAgent.indexOf('ipad') !== -1 && userAgent.indexOf('safari') !== -1) ||
    (userAgent.indexOf('macintosh') !== -1 &&
      'ontouchend' in document &&
      userAgent.indexOf('safari') !== -1)
  );
};

// PCまたはSPの判定
export const isSmartPhone = () => {
  return window.matchMedia && window.matchMedia('(max-device-width: 768px)').matches ? true : false;
};

/**
 * IOSスマホ・タブレットの場合・・・safari・chromeの場合にtrueになる
 * それ以外の場合・・・safariの場合trueになる
 */
export const isIOSsafariChromeOrPcSafari = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  // IOSスマホ・タブレットの場合
  if (isIOS() || isIpad()) {
    return userAgent.indexOf('safari') !== -1 || userAgent.indexOf('crios') !== -1;
  } else {
    // note chrome・edgeの場合safariの文字列が含まれる
    return (
      userAgent.indexOf('safari') !== -1 &&
      userAgent.indexOf('chrome') === -1 &&
      userAgent.indexOf('edge') === -1
    );
  }
};

// iPhone・Ipodか判定
export const isIOS = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return userAgent.indexOf('iphone') !== -1 || userAgent.indexOf('ipod') !== -1;
};

// ipadか判定を行う
export const isIpad = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return (
    userAgent.indexOf('ipad') !== -1 ||
    (userAgent.indexOf('macintosh') !== -1 && 'ontouchend' in document)
  );
};
